import webBiLogger from '@wix/web-bi-logger';
import { workspaceSelectorAccountSelected, workspaceSelectorFormLoad, } from '@wix/bi-logger-login-react-app/v2';
var biLogger = webBiLogger.factory().logger();
export var reportWorkspaceSelectorLoaded = function (originInfo) {
    return biLogger.report(workspaceSelectorFormLoad({
        origin_info: originInfo,
    }));
};
export var reportWorkspaceSelected = function (accountId, originInfo) {
    return biLogger.report(workspaceSelectorAccountSelected({
        account_id_selected: accountId,
        origin_info: originInfo,
    }));
};
//# sourceMappingURL=bi.service.js.map